import script from "./BaseCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCalendar.vue?vue&type=script&setup=true&lang=js"

import "./BaseCalendar.vue?vue&type=style&index=0&id=1fd3ae70&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fd3ae70"]])

export default __exports__